import Cookies from 'js-cookie'
import { STORAGE_ITEM, AUTH_COOKIE } from '@/libs/constants'

function setAuthToken (data) {
  if (!data.accessToken || !data.refreshToken) {
    throw new Error('invalid accessToken')
  }
  const tokenData = {
    accessToken: data.accessToken,
    refreshToken: data.refreshToken
  }
  localStorage.setItem(STORAGE_ITEM.authToken, JSON.stringify(tokenData))
}

export function setRefreshedAuthToken (token) {
  const tokenData = getAuthToken()
  tokenData.accessToken = token
  localStorage.setItem(STORAGE_ITEM.authToken, JSON.stringify(tokenData))
}

function removeAuthToken () {
  localStorage.removeItem(STORAGE_ITEM.authToken)
}

export function getAuthToken () {
  const tokenStr = localStorage.getItem(STORAGE_ITEM.authToken)
  if (tokenStr) {
    return JSON.parse(tokenStr)
  }
  return null
}

function setAuthCookie () {
  Cookies.set(AUTH_COOKIE.name, AUTH_COOKIE.value, {
    expires: AUTH_COOKIE.expires,
    path: AUTH_COOKIE.path,
    domain: AUTH_COOKIE.domain
  })
}

function removeAuthCookie () {
  Cookies.remove(AUTH_COOKIE.name, {
    path: AUTH_COOKIE.path,
    domain: AUTH_COOKIE.domain
  })
}

export function getAuthCookie () {
  return Cookies.get(AUTH_COOKIE.name, {
    path: AUTH_COOKIE.path,
    domain: AUTH_COOKIE.domain
  })
}

export function setAuthData (data) {
  setAuthToken(data)
  setAuthCookie()
}

export function removeAuthData () {
  removeAuthToken()
  removeAuthCookie()
}
